import(/* webpackMode: "eager" */ "/app/app/nextjs/app/(site)/error.tsx");
